/**
 * Collection Infinite Scroll
 *
 * Adds infinite scroll functionality to collection pages
 * Works with both initial page load and after filter changes
 */

let infiniteScrollInstance;

class InfiniteScroll {
  constructor() {
    this.infiniteScrollTrigger = null;
    this.productsGrid = null;
    this.loadingIndicator = null;
    this.isLoading = false;
    
    this.boundScrollHandler = this.checkScrollPosition.bind(this);
    this.boundFilterHandler = this.reinitialize.bind(this);
    
    this.initialize();
    
    document.addEventListener('shopify:section:load', this.boundFilterHandler);
    window.addEventListener('popstate', this.boundFilterHandler);
  }
  
  initialize() {
    this.findElements();
    
    if (!this.infiniteScrollTrigger) return;
    
    window.addEventListener('scroll', this.boundScrollHandler);
  }
  
  findElements() {
    this.infiniteScrollTrigger = document.querySelector("[data-infinite-scroll]");
    this.productsGrid = document.querySelector("#product-grid");
    this.loadingIndicator = document.querySelector("#loader");
  }

  reinitialize() {
    window.removeEventListener('scroll', this.boundScrollHandler);
    
    setTimeout(() => {
      this.isLoading = false;
      this.initialize();
    }, 500);
  }
  
  checkScrollPosition() {
    if (!this.infiniteScrollTrigger || this.isLoading) return;

    const windowBottom = window.scrollY + window.innerHeight;
    const triggerPosition = this.infiniteScrollTrigger.offsetTop;

    if (windowBottom > triggerPosition - 300) {
      this.loadMoreProducts();
    }
  }

  loadMoreProducts() {
    this.isLoading = true;
    
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'block';
    }
    
    const nextPageUrl = this.infiniteScrollTrigger.getAttribute('href');
    if (!nextPageUrl) {
        this.isLoading = false;
        if (this.loadingIndicator) this.loadingIndicator.style.display = 'none';
        return;
    }
    
    fetch(nextPageUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Sayfa yüklenemedi');
        }
        return response.text();
      })
      .then(html => {
        this.processNewProducts(html);
      })
      .catch(error => {
        console.error('Ürünler yüklenirken hata:', error);
        this.isLoading = false;
        if (this.loadingIndicator) {
          this.loadingIndicator.style.display = 'none';
        }
      });
  }

  processNewProducts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const newProducts = doc.querySelectorAll('#product-grid .collection__grid__item');
    
    if (newProducts.length === 0) {
      this.isLoading = false;
      if (this.loadingIndicator) this.loadingIndicator.style.display = 'none';
      if (this.infiniteScrollTrigger) {
        this.infiniteScrollTrigger.remove();
        this.infiniteScrollTrigger = null;
      }
      window.removeEventListener('scroll', this.boundScrollHandler);
      return;
    }
    
    const fragment = document.createDocumentFragment();
    newProducts.forEach(product => {
      fragment.appendChild(product.cloneNode(true));
    });
    
    this.productsGrid.appendChild(fragment);
    
    const nextPageLink = doc.querySelector('[data-infinite-scroll]');
    
    if (nextPageLink) {
      const newNextUrl = nextPageLink.getAttribute('href');
      this.infiniteScrollTrigger.setAttribute('href', newNextUrl);
    } else {
      if (this.infiniteScrollTrigger) {
        this.infiniteScrollTrigger.remove();
        this.infiniteScrollTrigger = null;
      }
      window.removeEventListener('scroll', this.boundScrollHandler);
    }
    
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = "none";
    }
    
    document.dispatchEvent(new CustomEvent('theme:products:loaded'));
    
    this.isLoading = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  infiniteScrollInstance = new InfiniteScroll();
});

// Listen for filter changes (using a custom event that should be dispatched by the theme)
document.addEventListener('facets:change', () => {
    if (infiniteScrollInstance) {
        infiniteScrollInstance.reinitialize();
    }
});